import React, { useMemo } from 'react';
import { useLanguage } from '../../../../locale/useLanguage';
import {
  PurchaseItem,
  PurchaseStatus,
} from '../../../../models/payment.models';

import './TransactionSection.css';

type TransactionSectionProps = {
  purchaseItem: PurchaseItem;
};

export const TransactionSection: React.FC<TransactionSectionProps> = ({
  purchaseItem,
}) => {
  const [t] = useLanguage();

  const orderState = useMemo(() => {
    switch (purchaseItem.status) {
      case PurchaseStatus.New:
        return t('orderDetails.orderStateWaitingForPayment');
      case PurchaseStatus.Error:
        return t('orderDetails.orderStateError');
      case PurchaseStatus.Finalized:
        return t('orderDetails.orderStatePayed');
      case PurchaseStatus.Canceled:
        return t('orderDetails.orderStateCanceled');
    }
  }, [purchaseItem.status, t]);

  return (
    <div>
      <div className="transaction-section--details-container">
        <p className="transaction-section--small-text transaction-section--text-medium">
          {t('orderDetails.details')}
        </p>
        <p className="transaction-section--small-text">
          {t('orderDetails.order')}: {purchaseItem.orderId}
        </p>
        <p className="transaction-section--small-text">
          {t('orderDetails.transaction')}: {purchaseItem.purchaseId}
        </p>
        <p className="transaction-section--small-text">
          {t('orderDetails.orderState')}: {orderState}
        </p>
      </div>
    </div>
  );
};
